<div class="row m-0">
    <div class="col-lg-12">
        <div class="haven-table user-table border-0">
            <div class="row m-0 haven-table-header">
                <div class="col-2">
                    <span class="sort-header">
                        {{ userLiterals.USERID }}
                    </span>
                </div>
                <div class="col-2">
                    <span class="sort-header">
                        {{ userLiterals.DOCID }}
                    </span>
                </div>
                <div class="col-2">
                    <span class="sort-header">
                        {{ userLiterals.ACCESSDATE }}
                    </span>
                </div>
                <div class="col-2">
                    <span class="sort-header">
                        {{ userLiterals.ACCESSMETHOD }}
                    </span>
                </div>
            </div>
            <div *ngIf="!data.length">
                <div class="width100 text-center">
                    <span class="noData">{{ userLiterals.NO_DATA_FOUND}}</span>
                </div>
            </div>
            <div class="scroll-grid haven-table-body" *ngIf="data && data.length">
                <div class="row m-0" *ngFor="let row of data">
                    <div class="col-2" [title]="row.userId">
                        {{ row.userId }}
                    </div>
                    <div class="col-2" [title]="row.docId">
                        {{ row.docId }}
                    </div>
                    <div class="col-2" [title]="row.accessDate | localDate ">
                        {{ row.accessDate | localDate }}
                    </div>
                    <div class="col-2" [title]="row.accessType">
                        {{ row.accessType }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row m-0 pt-4" *ngIf="data && data.length">
    <div class="col-12 float-right pagination loader-footer">
        <haven-loader [loaderEnabled]="isLoadingFooter"></haven-loader>
        <a href="javascript:void(0)">1 to {{ data.length }} <span *ngIf="loadMoreInfo?.totalCount > 0">of</span> {{ loadMoreInfo?.totalCount }} </a>
        <a class="load-more-btn pd0 mg0" *ngIf="!loadMoreInfo?.isEOF" href="javascript:void(0)" (click)="loadMoreDataClick();">{{
            userLiterals.LOADMORE_TXT }}</a>
    </div>
</div>
